import axios from './axios';

export interface CustomerDiscount {
  id: number;
  code: string;
  name: string;
  description: string | null;
  category: string;
  type: string;
  value: number;
  minimumOrderAmount: number | null;
  maximumDiscountAmount: number | null;
  usageLimit: number | null;
  usedCount: string;
  isActive: boolean;
  startsAt: string;
  expiresAt: string | null;
  appliesTo: string;
  eligibleProductIds: number[] | null;
  eligibleCollectionIds: number[] | null;
  isBirthdayCoupon: boolean;
  validDaysBeforeBirthday: number | null;
  validDaysAfterBirthday: number | null;
  combinable: boolean;
  promotionName: string | null;
  promotionDescription: string | null;
  importantNotice: string | null;
  isExpired: boolean;
  daysUntilExpiry: number | null;
  canUse: boolean;
  eligibilityReason: string;
  isBirthdaySpecial: boolean;
}

export interface CustomerDiscountsResponse {
  customerId: string;
  discounts: CustomerDiscount[];
  totalCount: number;
  message: string;
}

export const getCustomerDiscounts = async (): Promise<CustomerDiscountsResponse> => {
  const response = await axios.get('/api/customer-discounts');
  return response.data;
};
